import { render, staticRenderFns } from "./s05-risks.vue?vue&type=template&id=19883575&scoped=true"
import script from "./s05-risks.vue?vue&type=script&lang=js"
export * from "./s05-risks.vue?vue&type=script&lang=js"
import style0 from "./s05-risks.vue?vue&type=style&index=0&id=19883575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19883575",
  null
  
)

export default component.exports